import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/AuthContext";
import Login from "@/components/Login";
import ForgotPassword from "@/components/ForgotPassword";
import ResetPassword from "@/components/ResetPassword";
import AppShell from "@/components/AppShell";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="full-loader" data-testid="loading">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="full-loader">Loading…</div>;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename={process.env.REACT_APP_BASENAME || "/"}>
        <Routes>
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/forgot-password" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/*" element={<Protected><AppShell /></Protected>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
